import React, { ReactElement, } from 'react'

type Props ={
  size:number
  children?: ReactElement|ReactElement[]
}
/**
 * 元素间隔组件，为了解决元素间隔问题，使用方式如下：
 * ps：css gap 属性不兼容部分浏览器，这个组件可以解决这个问题
 * <Space size={10}>
 *  <Button>xx</Button>
 *  <Button>xx</Button>
 * </Space>
 * @param param0
 * @returns
 */
export default function Space({ children, size }:Props) {
  const count = React.Children.count(children)
  return React.Children.map(children, (item, i) => {
    if (i > 0 && i < count) {
      return [<div style={{ width: size, display: 'inline-block' }} />, item]
    }
    return item
  }) as unknown as ReactElement
}
